import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotate = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_904_1460",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 16,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0_904_1460)" }),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_904_1460)",
			children: [/* @__PURE__ */ _jsx("path", { d: "M14.8966 6.88611H9.0205C8.68031 6.88611 8.40503 7.16319 8.40503 7.50559V13.3806C8.40503 13.723 8.68031 14.0001 9.0205 14.0001H14.8966C15.2368 14.0001 15.5121 13.723 15.5121 13.3806V7.50559C15.5121 7.16319 15.2368 6.88611 14.8966 6.88611ZM14.2811 12.7611H9.63598V8.12508H14.2811V12.7611Z" }), /* @__PURE__ */ _jsx("path", { d: "M5.09176 7.38837L3.64036 8.77151C3.63365 8.66676 3.63029 8.56089 3.63029 8.45501C3.63029 5.57835 5.95567 3.23894 8.81259 3.23894C9.48513 3.23894 10.1387 3.36622 10.7564 3.61852C11.0719 3.74692 11.43 3.59374 11.5576 3.27724C11.6852 2.96074 11.533 2.59918 11.2185 2.47078C10.4531 2.15879 9.64404 2.0011 8.81259 2.0011C5.27641 1.99997 2.39934 4.89579 2.39934 8.45501C2.39934 8.59355 2.40382 8.73209 2.41277 8.87063L1.12699 6.94685C0.936751 6.66301 0.555157 6.58755 0.273158 6.77902C-0.00884122 6.9705 -0.0838172 7.35458 0.10642 7.63842L2.23596 10.8248C2.33668 10.9758 2.49894 11.0749 2.6791 11.0951C2.70148 11.0974 2.72387 11.0985 2.74737 11.0985C2.90403 11.0985 3.0551 11.0388 3.17036 10.9285L5.94 8.28832C6.18731 8.05291 6.19738 7.66094 5.9635 7.41202C5.72962 7.16423 5.34019 7.15297 5.09288 7.38837H5.09176Z" })]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_904_1460",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 15.5122,
				height: 12,
				fill: "white",
				transform: "translate(0 2)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgRotate);
export default ForwardRef;
